var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"aki-progress",class:{loading: _vm.loading},attrs:{"viewBox":_vm.box,"width":_vm.width}},[_c('circle',{attrs:{"stroke-dasharray":_vm.dash,"cx":_vm.r,"cy":_vm.r,"r":_vm.r - 4,"fill":"none","stroke-width":_vm.stroke}})])}
var staticRenderFns = []

export { render, staticRenderFns }